import { Reducer } from "../../lib/redux";
import { ITrailerAttachment } from "../../model/TrailerAttachment";
import { extend } from "../../utils/vanilla";
import { TrailerAttachmentActions } from "./actions";
import { TrailerAttachmentActionTypes } from "./types";

export let defaultTrailerAttachments: IIdDictionary<IIdDictionary<ITrailerAttachment>> = {};

export let trailerAttachments: Reducer<IIdDictionary<IIdDictionary<ITrailerAttachment>>, TrailerAttachmentActions> = (state = defaultTrailerAttachments, action) => {
    switch (action.type) {
        case TrailerAttachmentActionTypes.SET_TRAILER_ATTACHMENTS: {
            const userId = action.payload.userId;
            const trailerAttachment: IIdDictionary<ITrailerAttachment> = extend(true, {}, action.payload.trailerAttachments) || {};
            if (userId) {
                return {
                    ...state,
                    [userId]: trailerAttachment
                };
            }
            return state;
        }
        case TrailerAttachmentActionTypes.CLEAR_TRAILER_ATTACHMENTS: {
            if (action.payload) {
                let newState = {...state};
                delete newState[action.payload];
                return newState;
            }
            return state;
        }
        default:
            return state;
    }
};